<!-- Header Section Code Start -->
<main>
<header>
  <div class="header-section header-section-with-menu">
    <div class="container">
      <div class="dashboard-logo">
        <a>
          <img src="/assets/images/dashboard-logo.png" alt="American Bankers Association Logo" />
        </a>
      </div>
    </div>
  </div>
</header>
</main>
<!-- Header Section Code End -->
<div class="main_wraper mt-40 mb-30 center change-pwd-wrapper pull-left full-width">
  <div class="full-width center mb-20"> Username: <b>{{user_email}}</b></div>
  <p class="full-width center mb-20"> Password was successfully updated. <a href="javascript:void(0)"
      (click)="Sigin()">Click here to login</a></p>
</div>

<!-- Copy Right Section Code Start -->
<div class="dasboard-copy-right" role="contentinfo">
  Copyright © {{ currentYearCopyRight }} American Bankers Association. All Rights Reserved.
</div>
<!-- Copy Right Section Code End -->